import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  setUserRole(role: any) {
    throw new Error("Method not implemented.");
  }
  constructor(private http: HttpClient) {}

  getResults() {
    return this.http.get(`${environment.apiUrl}/admin/results`);
  }

  postLogin(payload: any) {
    return this.http.post(`${environment.apiUrl}/user/login`, payload);
  }

  createUser(payload: any) {
    return this.http.post(`${environment.apiUrl}/user/create`, payload);
  }

  getAllUsers() {
    return this.http.get(`${environment.apiUrl}/user/get-all`);
  }

  getOneUserById(id: string) {
    return this.http.get(`${environment.apiUrl}/user/get-one/${id}`);
  }

  updateUser(payload: any) {
    return this.http.put(`${environment.apiUrl}/user/update`, payload);
  }

  getPagedUsers(payload: {
    pageIndex: number;
    pageSize: number;
    filters: any;
    sortField?: string;
    sortOrder?: number;
  }) {
    const requestPayload = {
      ...payload,
    };
    return this.http.post(
      `${environment.apiUrl}/user/get-paged`,requestPayload
    );
  }


  changePassword(payload: { id: string; oldPassword: string; password: string }) {
    return this.http.post(`${environment.apiUrl}/user/change-password`, payload);
  }
}
